<template>
  <div>
    <Header :logoUrl="logoUrl" />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from "../core/Header";
import Footer from "../core/Footer.vue";
export default {
  name: "CiudadSalud",
  data() {
    return {
      logoUrl: "https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ciudadsalud/terrenoLogo/ciudadsalud_logo.svg",
    };
  },
  components: {
    Header,
    Footer,
  },
};
</script>
<style>
:root {
  --animate-duration: 250ms;
  --animate-delay: 0.9s;
}
.quick {
  transition-duration: "0ms" !important;
}
</style>
